import { render, staticRenderFns } from "./StartInfosForm.vue?vue&type=template&id=6e4bf728&scoped=true&"
import script from "./StartInfosForm.vue?vue&type=script&lang=js&"
export * from "./StartInfosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4bf728",
  null
  
)

export default component.exports